import React, { useEffect, useState } from 'react'
import Movie from './components/Movie';
import SearchIcon from '@material-ui/icons/Search';
import Footer from './components/Footer'


const FEATURED_API = "https://api.themoviedb.org/3/discover/movie?sort by=popularity.desc&api_key=04c35731a5ee918f014970082a0088b1&page=1";


const SEARCH_API = "https://api.themoviedb.org/3/search/movie?&api_key=04c35731a5ee918f014970082a0088b1&query=";



const App = () => {

    const [movies, setMovies] = useState([])
    const [search, setSearch] = useState("")

    const getMovies=(API)=>{
        fetch(API)
            .then(response => response.json())
            .then(json => {
                setMovies(json.results)
            })

    }

    useEffect(() => {
        getMovies(FEATURED_API)
    }, [])

    const handleOnSubmit = (e) => {
        e.preventDefault()

       getMovies(SEARCH_API + search)

        setSearch("")

    }


    return (
        <div className="app">
            <header>
                <div className="brand-name">
                    <span className="a">F</span>
                    <span className="b">U</span>
                    <span className="c">L</span>
                    <span className="d">L</span>
                    <span className="e">S</span>
                    <span className="f">C</span>
                    <span className="g">R</span>
                    <span className="h">E</span>
                    <span className="i">E</span>
                    <span className="j">N</span>
                    <span className="k">-</span>
                    <span className="l">FX</span>

                </div>
                <div className="formContainer">
                    <SearchIcon />
                <form onSubmit={handleOnSubmit} >
                    <input className="search" type="text" placeholder="Search" value={search} onChange={(e) => setSearch(e.target.value)} />

                </form>
                </div>

            </header>
            <div className="movie-container" >

                {movies.length > 0 &&
                    movies.map(movie =>
                        <Movie key={movie.id} {...movie} />
                    )
                }
            </div>
            <div className="footerContainer">
                <Footer/>
            </div>
        </div>
    )
}


export default App;

